import { Location, registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl-BE';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BarController, BarElement, CategoryScale, Chart, Colors, Legend, LinearScale, Tooltip } from 'chart.js';
import moment from 'moment';

import { environment } from './environments/environment';

import { AppComponent } from '~/app.component';
import { appConfig } from '~/app.config';
import { installDragAndDropPatch } from '~/utils/drag-and-drop/drag-and-drop-patch';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Colors, Legend, Tooltip);
registerLocaleData(localeNl, 'nl');
moment.locale('nl-be');
document.documentElement.lang = 'nl';

// next function added to load suite urls ending with a slash (/) correctly in de suite-view iframe
// remove this when suite-view iframe is removed21
Location.stripTrailingSlash = (url: string) => {
  return url;
};

if (environment.PRODUCTION) {
  enableProdMode();
}

async function bootstrap() {
  const { provideKeycloakConfig } = await import('~/keycloak.config');
  const keycloakProviders = await provideKeycloakConfig();

  const config = {
    ...appConfig,
    providers: [...appConfig.providers, ...keycloakProviders]
  };

  return bootstrapApplication(AppComponent, config);
}

bootstrap().catch((err) => console.error(err));

installDragAndDropPatch();
